/*========================================
        Imports!!!
=========================================*/

/*--css--*/
import '../assets/css/dom.css';
import Header from './header.js';
import Footer from './footer.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

/*--img in content--*/
import Main from '../assets/img/short4.jpg';

import sprzet7 from '../assets/produkty/agregat.webp';
import sprzet8 from '../assets/produkty/nagOlejowa.webp';
import sprzet9 from '../assets/produkty/osuszacz.webp';

/*========================================
        Middle!!!
=========================================*/

function Middle() {
    return (
        <>
        <section className='Middle'>
            {/*--stick publicity--*/}
            <section className='publicity'>
                <Row className='entry'>
                    {/*--text--*/}
                    <Col lg={5} md={12} sm={12} className='p-1 describe'>
                        <h1>Zasilanie</h1>
                        <h5>
                            Zapasowe źródła zasilania gwarantują ciągłość pracy w razie awarii prądu. Agregaty i oświetlenie sprawdzą się w każdych warunkach, szczególnie podczas akcji ratowniczych.
                        </h5>
                    </Col>
                    {/*--img--*/}
                    <Col lg={6} md={12} sm={12} className='lg-p-3 xs-p-1'>
                        <div className="image-container">
                            <img src={Main} alt='ilustrations of the main theme'/>    
                        </div>
                    </Col >
                </Row>
                {/*--choose the stick--*/}
                    <section className='ChooseYour'>
                    <Row className='EquipRow'>
                        <Col className='equipment'>
                            <img src={sprzet7} alt="sprzęt ilustracja"/>
                            <span>Agregat prądotwórczy</span>
                        </Col>
                        <Col className='equipment'>
                            <img src={sprzet8} alt="sprzęt ilustracja"/>
                            <span>Nagrzewnice olejowe</span>
                        </Col>
                        <Col className='equipment'>
                            <img src={sprzet9} alt="sprzęt ilustracja"/>
                            <span>Osuszacze</span>
                        </Col>
                    </Row>  
                </section>
            </section>
          </section>
        </>
    );
}

function Equipment() {
    return (
        <>
          <Header />
          <Middle/>
          <Footer/> 
        </>
    );
}

export default Equipment;